var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuduImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 10.5,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#2D6DBE",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: "18px",
    letterSpacing: 1
  }, "\r\n        VUDU\r\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuduImg);
export default __webpack_public_path__ + "static/media/VUDU-img.fff94bcb3e18004aebc37ce399b74d1d.svg";
export { ForwardRef as ReactComponent };